import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getPackageDetailsApi } from "../utils/constants";

export const getPackageDetail = createAsyncThunk("getPackageDetail", async () => {
    try {
        const config = {
            headers: {
                Authorization: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImFhYXNzc0B5b3BtYWlsLmNvbSIsImlkIjoiNjM4YzhhYTUtYzU0NC00YzcxLWI3YWEtZTI2ZjBlOGZkNzFiIiwidXNlclR5cGUiOiJVU0VSIiwicGxhdGZvcm0iOiJXRUIiLCJpYXQiOjE3NDAzNzg0MjJ9.qTM6H1yVzhMhNDHsvdUHgcP22Oed8aX5hbFh_YwEW4",
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
            },
        };
        const url = ApiBaseUrl + getPackageDetailsApi;
        const response = await axios.get(url, config);
        return response.data;
    } catch (error) {
        alert(error.response.data.message);
        throw error.response.data;
    }
});
const GetPackageDetailSlice = createSlice({
    name: "getPackageDetailReducer",
    initialState: {
        isLoading: false,
        data: null,
    },
    reducers: {
        clearGetPackageDetailData: (state) => {
            state.data = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPackageDetail.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPackageDetail.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
            })
            .addCase(getPackageDetail.rejected, (state) => {
                state.isError = false;
            });
    },
});

export const { clearGetPackageDetailData } = GetPackageDetailSlice.actions;
export default GetPackageDetailSlice.reducer;